import { createAction } from "@reduxjs/toolkit";
import { AIDuplicateTrainedModel, TrainedModel } from "../../@shared/Models/Models";
import { ModelType } from "../../@shared/Models/ModelTypes";

export const openTrainedModelModalAction = createAction<string>('openTrainedModelModalAction');
export const editTrainedModelModalAction = createAction<TrainedModel>('editTrainedModelModalAction');

export const closeTrainedModelModalAction = createAction('closeTrainedModelModalAction');
export const saveTrainedModelModalAction = createAction('saveTrainedModelModalAction');

export const openRunModelModalAction = createAction<TrainedModel>('openRunModelModalAction');
export const changeAIModelTrainerTypeId = createAction<ModelType>('changeAIModelTrainerTypeId');

export const closeRunModelModalAction = createAction('closeRunModelModalAction');
export const runModelModalAction = createAction('runModelModalAction');

export const closeOnnxModalAction = createAction('closeOnnxModalAction');
export const uploadOnnxModalAction = createAction<File>('uploadOnnxModalAction');
export const openOnnxModalAction = createAction<string>('openOnnxModalAction');

export const removeTrainedModelAction = createAction<string>('removeTrainedModelAction');

export const openDuplicateModelModalAction = createAction<string>('openDuplicateModelModalAction');
export const closeDuplicateModelModalAction = createAction('closeDuplicateModelModalAction');
export const createDuplicateModelAction = createAction<AIDuplicateTrainedModel>('createDuplicateModelAction');

